import { BaseService } from '@/core/base-service';

export default class CallForTenderAdminService extends BaseService<any> {
  public constructor() {
    super('services/serviceauttech/api/admin/call-for-tender');
  }
}
